'use client';

import type { ReactNode } from 'react';
import { ToastProvider } from '~/components/Toast';
import { CurrencyState } from '~/contexts/Currencies';
import type { CurrencyName } from '~/utils/currencyHelpers';

interface SharedProvidersProps {
  children: ReactNode;
  initialCurrency?: CurrencyName;
}

// ClerkProvider lives in the root layout, not here: `dynamic` is only honoured by Clerk's server
// build, and '@clerk/nextjs' resolves to the client build inside a 'use client' module.
export function SharedProviders({ children, initialCurrency }: Readonly<SharedProvidersProps>) {
  return (
    <CurrencyState initialCurrency={initialCurrency}>
      <ToastProvider>{children}</ToastProvider>
    </CurrencyState>
  );
}
